import React from 'react';
import { Countdown } from './Countdown';
export function Urgency() {
  return <section className="w-full bg-cream" data-id="element-316" data-mp="2bwe6imbbrd3g">
      <div className="max-w-3xl mx-auto px-5 py-14 sm:py-16 text-center" data-id="element-317" data-mp="2bvcw8k24uums">
        <p className="text-[12px] font-bold uppercase tracking-[1.6px] text-coral-deep" data-id="element-318" data-mp="1x06nhpbnkhpr">
          Launch offer
        </p>
        <h2 className="mt-3 font-display text-plum text-2xl sm:text-4xl" data-id="element-319" data-mp="21x6sry0ohgft">
          The launch price ends in:
        </h2>
        <div className="mt-6" data-id="element-320" data-mp="1o5s71jfdz152">
          <Countdown tone="light" data-id="element-321" data-mp="1sxjrrdbv2cna" />
        </div>
        <p className="mt-5 text-sm text-ink-soft" data-id="element-322" data-mp="1szd0cy61b6xx">
          After that the price goes up by{' '}
          <span className="font-semibold text-coral-deep" data-id="element-323" data-mp="1eagth4fprzyw">$5</span> and stays
          there.
        </p>
      </div>
    </section>;
}